import styled from 'styled-components';
import SelectInput from '../../UI/inputs/Select';
import Button from '../../UI/buttons/Button';
import { ReactComponent as DownloadIcon } from '../../icons/download.svg';

// Main form container used across management screens
export const ManagementForm = styled.div`
  padding: 1.5rem 2rem 0;
  border-radius: ${({ theme }) => theme.radius};
  background: #ffffff;
  margin-bottom: 1rem;
  position: sticky;
  top: 0;
  z-index: 998;
  @media (max-width: 576px) {
    position: relative;
  }
`;

// No result text styling
export const NoResultText = styled.p`
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.33;
  letter-spacing: 0.96px;
  text-align: center;
  color: #061c2e;
  padding: 1rem;
`;

// Table wrapper styling
export const TableWrapper = styled.div`
  background: #ffffff;
  border-radius: ${({ theme }) => theme.radius};
`;

// Multi-select input styling
export const MultiSelectInput = styled(SelectInput)`
  &.ant-select-multiple {
    & .ant-select-selection-item {
      line-height: 1.5rem;
      font-size: 0.75rem;
      color: #4b6276;
      border-radius: 0.25rem;
      background-color: ${({ theme }) => theme.lozengeColor};
      padding: 0;
      padding-left: 5px;
    }
  }
`;

// Action button with icon styling
export const ActionButton = styled(Button)`
  box-sizing: border-box;
  height: 40px;
  &:disabled,
  &.disabled {
    height: 40px;
    cursor: not-allowed;
    background: #fff;
    color: #aebeca;
    border-color: #aebeca;
    &:hover {
      background: #dde7ee;
      color: #ffffff;
      border-color: #dde7ee;
      & path {
        transition: all 0.3s;
        stroke: #fff;
      }
    }
    & path {
      stroke: #aebeca;
    }
  }
`;

// Styled download icon
export const StyledDownloadIcon = styled(DownloadIcon)`
  width: 20px;
  height: 20px;
  margin-right: 0;
  stroke-width: 1.5;
  & path {
    stroke: ${({ theme }) => theme.primaryColor};
    &:disabled,
    &.disabled {
      stroke: #aebeca;
    }
  }
`; 